








import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class CProdClientLabelInput extends Vue {
  // Props

  @Prop()
  public value!: string;

  // Methods

  public onInput(value: string) {
    this.$emit("input", value);
  }
}
